import { render, staticRenderFns } from "./Patientendaten.vue?vue&type=template&id=2a9ae6eb"
import script from "./Patientendaten.vue?vue&type=script&lang=js"
export * from "./Patientendaten.vue?vue&type=script&lang=js"
import style0 from "./Patientendaten.vue?vue&type=style&index=0&id=2a9ae6eb&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports